import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
import { API_IPO_GO_LIVE } from "../../../config/api";
import { getIpo } from "./getIpo";

// data: { current_price?, available_volume? } — both optional.
export const goLiveIpo = createAsyncThunk(
  "ipos/goLive",
  async ({ id, data, callback }, { dispatch, rejectWithValue }) => {
    try {
      const response = await Client({
        method: "POST",
        path: API_IPO_GO_LIVE(id),
        data,
      });
      toast.success(response?.data?.message || "Offer listed successfully");
      dispatch(getIpo(id));
      callback && callback();
      return response?.data?.data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      return rejectWithValue(error.message);
    }
  }
);
